// eslint-disable-next-line import/prefer-default-export
export const mockData = {
  '/ceb-class-session/list': {
    data: [
      {
        active: true,
        attendance_status: 0,
        attendance_status_string: 'Pending Attendance',
        cancellation_reason: '',
        created_at: '2026-01-05T06:42:58.123Z',
        current_enrolment_count: 0,
        day_of_week: 1,
        end_time: '2026-01-05T06:42:58.123Z',
        final_enrolment_count: 0,
        fk_cancelled_user: 0,
        fk_class: 0,
        fk_rescheduled_user: 0,
        fk_room: 0,
        fk_session_type: 0,
        id: 1,
        reschedule_reason: '',
        session_duration: 0,
        start_date: '2026-01-05T06:42:58.123Z',
        start_time: '2026-01-05T06:42:58.123Z',
        status: 0,
        status_string: 'pending',
        updated_at: '2026-01-05T06:42:58.123Z',
      },
      {
        active: true,
        attendance_status: 0,
        attendance_status_string: 'Pending Attendance',
        cancellation_reason: '',
        created_at: '2026-01-05T06:42:58.123Z',
        current_enrolment_count: 0,
        day_of_week: 2,
        end_time: '2026-01-05T06:42:58.123Z',
        final_enrolment_count: 0,
        fk_cancelled_user: 0,
        fk_class: 0,
        fk_rescheduled_user: 0,
        fk_room: 0,
        fk_session_type: 0,
        id: 2,
        reschedule_reason: '',
        session_duration: 0,
        start_date: '2026-01-05T06:42:58.123Z',
        start_time: '2026-01-05T06:42:58.123Z',
        status: 2,
        status_string: 'completed',
        updated_at: '2026-01-05T06:42:58.123Z',
      },
      {
        active: true,
        attendance_status: 0,
        attendance_status_string: 'Pending Attendance',
        cancellation_reason: '',
        created_at: '2026-01-05T06:42:58.123Z',
        current_enrolment_count: 0,
        day_of_week: 5,
        end_time: '2026-01-05T06:42:58.123Z',
        final_enrolment_count: 0,
        fk_cancelled_user: 0,
        fk_class: 0,
        fk_rescheduled_user: 0,
        fk_room: 0,
        fk_session_type: 0,
        id: 3,
        reschedule_reason: '',
        session_duration: 0,
        start_date: '2026-01-05T06:42:58.123Z',
        start_time: '2026-01-05T06:42:58.123Z',
        status: 1,
        status_string: 'upcoming',
        updated_at: '2026-01-05T06:42:58.123Z',
      },
      {
        active: true,
        attendance_status: 0,
        attendance_status_string: 'Pending Attendance',
        cancellation_reason: '',
        created_at: '2026-01-05T06:42:58.123Z',
        current_enrolment_count: 0,
        day_of_week: 3,
        end_time: '2026-01-05T06:42:58.123Z',
        final_enrolment_count: 0,
        fk_cancelled_user: 0,
        fk_class: 0,
        fk_rescheduled_user: 0,
        fk_room: 0,
        fk_session_type: 0,
        id: 4,
        reschedule_reason: '',
        session_duration: 0,
        start_date: '2026-01-05T06:42:58.123Z',
        start_time: '2026-01-05T06:42:58.123Z',
        status: 4,
        status_string: 'cancelled',
        updated_at: '2026-01-05T06:42:58.123Z',
      },
    ],
    totalCount: 2,
  },
  '/ceb-session-type/list': {
    data: [
      {
        active: true,
        created_at: '2026-01-05T06:10:00.000Z',
        id: 1,
        label: 'Regular',
        updated_at: '2026-01-05T06:10:00.000Z',
      },
      {
        active: true,
        created_at: '2026-01-05T06:10:00.000Z',
        id: 2,
        label: 'Booster',
        updated_at: '2026-01-05T06:10:00.000Z',
      },
    ],
    totalCount: 2,
  },
  '/ceb-class/1': {
    id: 1,
    label: 'Chinese Compo for Lower Primary Class 1A',
    description: 'Class Description',
    fk_centre: 1,
    fk_program: 1,
    fk_level: 1,
    fk_class_type: 1,
    fk_room: 1,
    min_size: 5,
    max_size: 20,
    duration_in_minutes: 60,
    total_session: 12,
    from: '2023-01-01',
    to: '2023-12-31',
    is_cancelled: false,
    schedules: {
      totalCount: 1,
      data: [
        {
          id: 1,
          fk_class: 1,
          day_of_week: 1,
          start_time: '09:00:00',
          end_time: '10:00:00',
          active: true,
          created_at: '2023-01-01T00:00:00Z',
          updated_at: '2023-01-01T00:00:00Z',
        },
      ],
    },
    program: {
      id: 1,
      name: 'Chinese Composition for Lower Primary',
    },
    centre: {
      id: 1,
      label: 'Centre 1',
    },
    classroom: {
      id: 1,
      name: 'Thunder Room',
    },
    service_levels: [
      {
        id: 1,
        name: 'Infant',
      },
      {
        id: 2,
        name: 'Toddler',
      },
      {
        id: 3,
        name: 'Nursery',
      },
    ],
    assigned_teachers: [
      {
        id: 2006,
        name: 'Han Bingzhen',
      },
      {
        id: 2008,
        name: 'Falizah Binte Mohd Ali',
      },
      {
        id: 2010,
        name: 'Tan Jia Hui',
      },
    ],
    minimum_class_size: 5,
    maximum_class_size: 20,
  },
  '/ceb-class-teacher/list': {
    data: [
      {
        active: true,
        created_at: '2025-12-29 00:00:00',
        fk_class: 1,
        fk_teacher: 1,
        id: 1,
        updated_at: '2025-12-29 00:00:00',
        firstname: 'Han',
        lastname: 'Bingzhen',
      },
      {
        active: true,
        created_at: '2025-12-29 00:00:00',
        fk_class: 1,
        fk_teacher: 2,
        id: 2,
        updated_at: '2025-12-29 00:00:00',
        firstname: 'Falizah',
        lastname: 'Binte Mohd Ali',
      },
      {
        active: true,
        created_at: '2025-12-29 00:00:00',
        fk_class: 1,
        fk_teacher: 3,
        id: 3,
        updated_at: '2025-12-29 00:00:00',
        firstname: 'Tan',
        lastname: 'Jia Hui',
      },
    ],
    totalCount: 3,
  },
};
